// extracted by mini-css-extract-plugin
export default {"modal":"modal__RX7xu","formGroup":"formGroup"};